module.exports = __webpack_public_path__ + "img/triangle-rouge.b8be8884.png";